import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import YouTube from 'react-youtube'
import { YouTubePlayerMain } from './index.style'

// Player options https://developers.google.com/youtube/player_parameters

const YouTubePlayer = ({ data, options = {} }) => {
  const [videoId, setVideoId] = useState(); 
  const opts = {
    playerVars: {
      modestbranding: 1,
      autoplay: 1,
      controls: 0,
      loop: 1,
      ...options,
    },
  }
  useEffect(() => {
    if (data.videoId.includes('youtube.com/watch') || data.videoId.includes('youtu.be/')) {
      const urlParams = new URLSearchParams(new URL(data.videoId).search);
      const vid = urlParams.get('v') || data.videoId.split('/').pop();

      const videoIdParts = vid.split('?');
      const vids = videoIdParts[0];
  
      setVideoId(vids);
    }else{
      setVideoId(data.videoId)
    }
  }, []);

  return (
    <YouTubePlayerMain>
      {videoId && <YouTube className="youtube-player" videoId={videoId} opts={opts} />}
    </YouTubePlayerMain>
  )
}

YouTubePlayer.propTypes = {
  data: PropTypes.object,
}

export default YouTubePlayer
